/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { number as codecNumber } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { PermissionException } from './PermissionException';
const CourseUserLimitExceededExceptionParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['courseId', codecNumber, 'course_id'],
    ['userType', /* #__PURE__ */ parsers.exactly('staff', 'student'), 'user_type'],
    ['currentCount', codecNumber, 'current_count'],
    ['limit', codecNumber],
]), PermissionException);
export class CourseUserLimitExceededException extends PermissionException {
    static decode(input) {
        return CourseUserLimitExceededExceptionParser.decode(input).map(res => new CourseUserLimitExceededException(res));
    }
    static unsafeDecode(input) {
        return CourseUserLimitExceededException.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CourseUserLimitExceededExceptionParser.encode(data);
    }
    static schema() {
        return CourseUserLimitExceededExceptionParser.schema();
    }
}
